export default __webpack_public_path__ + "static/media/sendWhiteMode.9103498b.svg";